module.exports = __webpack_public_path__ + "media/Video 98.81b4201f.mp4";